import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MatchDetailLineupsTopBar from '../MatchDetailLineupsTopBar/MatchDetailLineupsTopBar';
import MatchDetailLineupsField from '../MatchDetailLineupsField/MatchDetailLineupsField';
import MatchDetailLineupsCoaches from '../MatchDetailLineupsCoaches/MatchDetailLineupsCoaches';
import MatchDetailLineupsBench from '../MatchDetailLineupsBench/MatchDetailLineupsBench';
import { getMatchesStatistics } from '../../../services/getMatchesStatistics';
import { buildLineupsData } from '../../../utils';
import './_MatchDetailLineups.scss';

/**
 * MatchDetailLineups — Large/Plantilla (node 106:11182)
 *
 * Componente orquestador. Recibe `lineups` desde props (API)
 * o usa LINEUPS_MOCK si no hay datos.
 *
 * Estructura:
 *   MatchDetailLineups
 *     └─ MatchDetailLineupsField   (campo + jugadores titulares)
 *          └─ MatchDetailLineupsPlayer  (card individual)
 *     └─ MatchDetailLineupsBench   (lista de suplentes)
 *
 * Sin flex ni grid. Conversión px→rem: (px / 1.5) / 10.
 */
class MatchDetailLineups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lineupsFromApi: [],
      useStateLineups: false
    };
    this.leagueId = props.leagueId;
    this.matchId = props.matchId;
    this._isMounted = false;
    this._lineupsRequestId = 0;
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentDidUpdate(prevProps) {
    const leagueChanged = prevProps.leagueId !== this.props.leagueId;
    const matchChanged = prevProps.matchId !== this.props.matchId;

    if (leagueChanged || matchChanged) {
      this.leagueId = this.props.leagueId;
      this.matchId = this.props.matchId;
    }

    if (prevProps.lineups !== this.props.lineups) {
      this.setState({ lineupsFromApi: [] });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  fetchLineupsFromApi = async () => {
    if (!this.leagueId || !this.matchId) return;

    const requestId = ++this._lineupsRequestId;
    const view = 'lineups';

    try {
      const matchLineups = await getMatchesStatistics(this.leagueId, this.matchId, view);
      if (!this._isMounted || requestId !== this._lineupsRequestId) return;

      const mappedLineups = buildLineupsData(matchLineups);
      this.setState(prevState => ({ lineupsFromApi: mappedLineups || prevState.lineupsFromApi }));
    } catch (error) {
      if (!this._isMounted || requestId !== this._lineupsRequestId) return;
    }
  }

  getLineupsToRender = () => {
    const { lineups } = this.props;
    const { lineupsFromApi, useStateLineups } = this.state;
    return Array.isArray(lineupsFromApi) && lineupsFromApi.length > 0 ? lineupsFromApi : lineups;
  }

  render() {
    const lineups = this.getLineupsToRender();
    if (!lineups) return null;

    var homeTeam = lineups.homeTeam || {};
    var awayTeam = lineups.awayTeam || {};
    var safeHomeTeam = Object.assign({ starters: [], bench: [], subBench: [] }, homeTeam);
    var safeAwayTeam = Object.assign({ starters: [], bench: [], subBench: [] }, awayTeam);

    return (
      <div className="match-detail-lineups">
        <MatchDetailLineupsTopBar lineups={lineups} />
        <MatchDetailLineupsField
          homeTeam={safeHomeTeam}
          awayTeam={safeAwayTeam}
        />
        <MatchDetailLineupsCoaches
          homeTeam={safeHomeTeam}
          awayTeam={safeAwayTeam}
        />
        <MatchDetailLineupsBench
          homeTeam={safeHomeTeam}
          awayTeam={safeAwayTeam}
        />
      </div>
    );
  }
}

MatchDetailLineups.propTypes = {
  lineups: PropTypes.shape({
    homeTeam: PropTypes.shape({
      name: PropTypes.string,
      shortName: PropTypes.string,
      flagUrl: PropTypes.string,
      teamColor: PropTypes.string,
      formation: PropTypes.string,
      coach: PropTypes.shape({
        name: PropTypes.string,
        photoUrl: PropTypes.string
      }),
      coachName: PropTypes.string,
      coachPhotoUrl: PropTypes.string,
      coachImage: PropTypes.string,
      starters: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          number: PropTypes.number,
          name: PropTypes.string,
          photoUrl: PropTypes.string,
          x: PropTypes.number,
          y: PropTypes.number,
          events: PropTypes.arrayOf(PropTypes.string)
        })
      ),
      bench: PropTypes.arrayOf(
        PropTypes.shape({
          number: PropTypes.number,
          name: PropTypes.string
        })
      )
    }),
    awayTeam: PropTypes.shape({
      name: PropTypes.string,
      shortName: PropTypes.string,
      flagUrl: PropTypes.string,
      teamColor: PropTypes.string,
      formation: PropTypes.string,
      coach: PropTypes.shape({
        name: PropTypes.string,
        photoUrl: PropTypes.string
      }),
      coachName: PropTypes.string,
      coachPhotoUrl: PropTypes.string,
      coachImage: PropTypes.string,
      starters: PropTypes.array,
      bench: PropTypes.array
    })
  }),
  leagueId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  matchId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

MatchDetailLineups.defaultProps = {
  lineups: null,
  leagueId: null,
  matchId: null
};

export default MatchDetailLineups;



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/Components/MatchDetailLineups/MatchDetailLineups.jsx